import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface MetricCardProps {
  readonly title: string;
  readonly value: string;
  /** Small supporting line under the value (e.g. "48 in progress"). */
  readonly subtitle?: ReactNode;
  /** Makes the whole tile a button. */
  readonly onClick?: () => void;
  /** Centers the content (dashboard KPI style). Defaults to false. */
  readonly center?: boolean;
}

/**
 * Dashboard metric tile. Pure CDS/MUI — colors, spacing, and typography come
 * from the Capital theme, never hardcoded. Optionally clickable + centered to
 * match the dense VSO KPI cards.
 */
export function MetricCard({ title, value, subtitle, onClick, center = false }: MetricCardProps) {
  const body = (
    <CardContent sx={{ textAlign: center ? 'center' : 'left' }}>
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, color: (theme) => theme.palette.text.secondary }}
      >
        {title}
      </Typography>
      <Typography variant="h3" sx={{ my: (theme) => theme.spacing(0.5) }}>
        {value}
      </Typography>
      {subtitle != null &&
        (typeof subtitle === 'string' ? (
          <Typography variant="caption" sx={{ color: (theme) => theme.palette.text.secondary }}>
            {subtitle}
          </Typography>
        ) : (
          subtitle
        ))}
    </CardContent>
  );

  if (onClick) {
    return (
      <Card sx={{ height: '100%' }}>
        <CardActionArea onClick={onClick} sx={{ height: '100%' }}>
          {body}
        </CardActionArea>
      </Card>
    );
  }

  return <Card sx={{ height: '100%' }}>{body}</Card>;
}
